import {
  CREATE_COURSE_COLLECTION_SUCCESS,
  DELETE_COURSE_COLLECTION_SUCCESS,
  COLLECTION_TRANSLATE_SUCCESS,
  COLLECTION_TRANSLATION_COMPLETE,
  LIST_COURSE_COLLECTION,
  LIST_COURSE_COLLECTION_SUCCESS,
  LIST_COURSE_COLLECTION_ERROR,
  UPDATE_COURSE_COLLECTION_SUCCESS,
  UPDATE_COURSE_COLLECTION_ERROR,
  COLLECTION_COURSE_PATCH,
  DRAWER_OPEN,
  SET_SELECTED_COLLECTION,
  SET_SELECTED_PAGE_VIEW,
  COURSE_TRANSPORT_CLICKED,
  TRANSPORTING_COURSE_SELECT,
} from './type'
import {
  addInProgress,
  removeInProgress,
  getInProgress,
  IN_PROGRESS_OPERATIONS,
} from 'src/utils/in-progress-storage'
//eslint-disable-next-line
export default function (
  state = {
    list: { courseDtos: [], courseCollectionDtos: [] },
    entity: null,
    query: null,
    collectionSettings: {},
    drawerOpen: false,
    selectedCollection: null,
    selectedPageView: 'Mini Courses',
    courseTransportClicked: false,
    // Seed from localStorage so the "Translating…" overlay survives a page refresh
    // even before the SignalR connection is up. Live-session updates below also
    // sync the storage on every change.
    translatingIds: getInProgress(IN_PROGRESS_OPERATIONS.TRANSLATION),
  },
  action,
) {
  const { payload, type } = action
  const recursive = (row, id, response) => {
    if (row.id === id) {
      row.rowChildList = response
    }

    if (row.rowChildList == null) {
      return null
    }

    row.rowChildList.results.forEach(childRow => {
      recursive(childRow, id, response)
    })
  }
  switch (type) {
    case CREATE_COURSE_COLLECTION_SUCCESS:
      let newFolderDto = payload.response.data
      let collectionList = [...state.list.courseCollectionDtos]
      if (
        collectionList.length > 0 &&
        collectionList[0].collectionName == 'Templates'
      ) {
        collectionList.splice(1, 0, newFolderDto)
        state = {
          ...state,
          list: {
            ...state.list,
            courseCollectionDtos: [...collectionList],
          },
        }
      } else {
        state = {
          ...state,
          list: {
            ...state.list,
            courseCollectionDtos: [newFolderDto, ...collectionList],
          },
        }
      }
      return state
    case DELETE_COURSE_COLLECTION_SUCCESS:
      let collectionId = payload.response
      state = {
        ...state,
        list: {
          ...state.list,
          courseCollectionDtos: state.list.courseCollectionDtos.filter(
            collection => {
              return collection.id !== collectionId
            },
          ),
        },
      }

      return state
    case LIST_COURSE_COLLECTION:
      return { ...state, query: payload.query }
    case LIST_COURSE_COLLECTION_SUCCESS:
      return { ...state, list: payload.response }
    case COLLECTION_TRANSLATE_SUCCESS:
      addInProgress(IN_PROGRESS_OPERATIONS.TRANSLATION, payload.id)
      return {
        ...state,
        translatingIds: [...(state.translatingIds || []), payload.id],
      }
    case COLLECTION_TRANSLATION_COMPLETE:
      removeInProgress(IN_PROGRESS_OPERATIONS.TRANSLATION, payload.id)
      return {
        ...state,
        translatingIds: (state.translatingIds || []).filter(id => id !== payload.id),
      }
    case UPDATE_COURSE_COLLECTION_SUCCESS:
      return { ...state }
    case LIST_COURSE_COLLECTION_ERROR:
      return { ...state, response: null }
    case UPDATE_COURSE_COLLECTION_ERROR:
      return { ...state, entity: null }

    case COLLECTION_COURSE_PATCH:
      let patchedCourse = state.list.courseDtos.filter(
        x => x.id == payload.content._id,
      )[0]

      payload.content._contents.map(value => {
        patchedCourse[value._path] = value.value
      })
      state = {
        ...state,
        list: {
          ...state.list,
          courseDtos: state.list.courseDtos.filter(course => {
            return course.id == payload.content._id
              ? (course = patchedCourse)
              : course
          }),
        },
      }
      return state

    case DRAWER_OPEN:
      state = {
        ...state,
        drawerOpen: !state.drawerOpen,
      }
      return state
    case SET_SELECTED_COLLECTION:
      state = {
        ...state,
        selectedCollection: payload.collectionId,
      }
      return state
    case SET_SELECTED_PAGE_VIEW:
      state = {
        ...state,
        selectedPageView: payload.pageView,
      }
      return state
    case COURSE_TRANSPORT_CLICKED:
      state = {
        ...state,
        courseTransportClicked: !state.courseTransportClicked,
      }
      return state
    case TRANSPORTING_COURSE_SELECT:
      state = {
        ...state,
        selectedCourse: payload.courseId,
      }
      return state
    default:
      return state
  }
}
